<template>
  <filter-template @submit="filter()">
    <v-row>
      <v-col cols="12">
        <input-select
          id="input:Type"
          v-model="payload.Type"
          :items="TypeOptions"
          label="Tipo"
          clearable
        />
      </v-col>
      <v-col cols="12">
        <input-select
          id="input:Category"
          v-model="payload.Category"
          :items="CategoryOptions"
          label="Categoria"
          clearable
        />
      </v-col>
      <v-col cols="12">
        <input-date
          id="input:MinCreatedAt"
          v-model="payload.MinCreatedAt"
          label="Data de criação inicial"
          :mask="'##/##/####'"
        />
      </v-col>
      <v-col cols="12">
        <input-date
          id="input:MaxCreatedAt"
          v-model="payload.MaxCreatedAt"
          label="Data de criação final"
          :mask="'##/##/####'"
        />
      </v-col>
      <v-col cols="12">
        <input-date
          id="input:MinUpdatedAt"
          v-model="payload.MinUpdatedAt"
          label="Data de atualização inicial"
          :mask="'##/##/####'"
        />
      </v-col>
      <v-col cols="12">
        <input-date
          id="input:MaxUpdatedAt"
          v-model="payload.MaxUpdatedAt"
          label="Data de atualização final"
          :mask="'##/##/####'"
        />
      </v-col>
    </v-row>
  </filter-template>
</template>

<script>
import FilterTemplate from '@/app/arch/components/crud/components/FilterTemplate.vue';
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';

export default {
  name: 'BannerFilter',
  components: { FilterTemplate },
  mixins: [FilterMixin],
  data: () => ({
    payload: {
      Type: '',
      Category: '',
      MinCreatedAt: '',
      MaxCreatedAt: '',
      MinUpdatedAt: '',
      MaxUpdatedAt: '',
    },
    TypeOptions: [
      {
        value: 'ProductsAndServices',
        text: 'Produtos e serviços',
      },
      {
        value: 'Informative',
        text: 'Informativos',
      },
    ],
    CategoryOptions: [
      {
        value: 'Home',
        text: 'Tela inicial',
      },
      {
        value: 'Store',
        text: 'Loja',
      },
    ],
  }),
};
</script>

<style>

</style>
